import { MOTOR_GIS_SUBCLASS_CODE, MOTOR_PROD_ID, MOTOR_PRODUCT_GROUP } from '@/constants/motorPrivate';

/** GIS policy numbers use branch/subclass-or-procode/serial[/year] — e.g. 080/0070/156820/2026 or 10/700/0108667 */
export function parsePolicySubclassSegment(policyNo) {
  if (!policyNo) return null;
  const parts = String(policyNo).replace(/-/g, '/').split('/').filter(Boolean);
  if (parts.length < 2) return null;
  return parts[1];
}

export function policySubclassCode(policyNo) {
  const segment = parsePolicySubclassSegment(policyNo);
  if (!segment) return null;
  const code = parseInt(segment, 10);
  return Number.isNaN(code) ? null : code;
}

/**
 * Motor policy-number middle segment can be:
 * - 70 / 0070  → product group / legacy subclass
 * - 700        → GIS standard motor product (POL_PRO_CODE)
 * - 3437       → portal motor private product (MOTOR_PROD_ID)
 */
export function isMotorPolicyNumber(policyNo) {
  const code = policySubclassCode(policyNo);
  return code === MOTOR_PRODUCT_GROUP
    || code === MOTOR_GIS_SUBCLASS_CODE
    || code === MOTOR_PROD_ID;
}

/** True when a GIS policy details payload is a motor product. */
export function isMotorPolicyDetails(policy) {
  if (!policy) return false;
  if (isMotorPolicyNumber(policy.policyNo)) return true;
  const productCode = Number(policy.productCode);
  if (productCode === MOTOR_GIS_SUBCLASS_CODE || productCode === MOTOR_PROD_ID) return true;
  const group = String(policy.productGroup || '').toUpperCase();
  return group.includes('MOTOR');
}

/** PA / travel have dedicated portal sections — exclude from Domestic Package list. */
export function isPaPolicyNumber(policyNo) {
  return policySubclassCode(policyNo) === 95;
}

export function isTravelPolicyNumber(policyNo) {
  return policySubclassCode(policyNo) === 94;
}

/** Policies from GET /gis/policies/byidnumber — only true domestic/home policies. */
export function isDomesticPackagePolicyNumber(policyNo) {
  if (!policyNo) return false;
  if (isMotorPolicyNumber(policyNo)) return false;
  if (isPaPolicyNumber(policyNo)) return false;
  if (isTravelPolicyNumber(policyNo)) return false;
  return true;
}
